import moment from 'moment'

export const sleep = (timeout = 200) => {
  return new Promise((resolve, reject) => {
    setTimeout(resolve, timeout)
  })
}

export function excelDown (data, name, type) {
  var elink = document.createElement('a')
  // elink.download = '报表数据-${new Date().getTime()}.xlsx'
  elink.style.display = 'none'
  var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
  elink.download = name

  elink.href = URL.createObjectURL(blob)
  document.body.appendChild(elink)
  elink.click()
  document.body.removeChild(elink)
  this.$message.success('导出成功!')
}

export function deepClone (obj) {
  const objClone = Array.isArray(obj) ? [] : {}
  if (obj && typeof obj === 'object') {
    for (const key in obj) {
      if (obj[key] && typeof obj[key] === 'object') {
        objClone[key] = this.deepClone(obj[key])
      } else {
        objClone[key] = obj[key]
      }
    }
  }
  return objClone
}

export function dateChange (value) {
  // 当天0点的以13位Unix时间戳输出（毫秒）
  const dateSelect = value ? moment(value._d).startOf('day').format('x') : ''
  return dateSelect
}

export function countSum (arr) {
  if (!arr.length) return 0
  arr = arr.map(v => {
    if (v && !Number.isNaN(Number(v))) return Math.round(v * 10000)
    return 0
  })
  const result = arr.reduce((prev, curr) => {
    return prev + curr
  }, 0)
  return result / 10000
};

export function filterOption (value, option) {
  return option.componentOptions.children[0].text.indexOf(value) >= 0
}

export function inputKeydown (e, getEvent) {
  // 回车键
  if (e.keyCode === 13) {
    getEvent()
  }
}
// // 计算最大值
// export function _calcMaxNumber (arr) {
//   const max = Math.max(...arr)
//   const maxInt = Math.ceil(max / 6)
//   const maxVal = maxInt * 10
//   return maxVal
// }
// // 计算最小值
// export function _calcMinNumber (arr) {
//   const min = Math.min(...arr)
//   const minInt = Math.floor(min / 6)
//   const minVal = minInt * 10
//   return minVal
// }
